import { NOTIFICATIONS_STORE_KEY } from '../constants';
import type { State } from '../reducers/notificationReducers';

export default (state: GlobalState) => state[NOTIFICATIONS_STORE_KEY] as State | undefined;
